import { makeVar } from '@apollo/client';
import { Admin } from '@graphql/types';

const userState = {} as Admin;
export const userVar = makeVar(userState);
